import useOrganizationSettings from '@app/src/hooks/useOrganizationSettings'
import { CONFIGURATION_PAGE_IDS } from '@app/src/pages/Configurations/ConfigurationsScene'
import paths from '@app/src/wf-constants/paths'
import { AutoAwesomeOutlined, ErrorOutlineOutlined } from '@mui/icons-material'
import { Button } from '@mui/material'
import { useTheme } from '@mui/styles'
import React from 'react'
import { useIntl } from 'react-intl'
import { generatePath, useHistory } from 'react-router'

const RemainingProviderScreeningsButton: React.FC = () => {
  const { formatMessage } = useIntl()
  const { palette } = useTheme()
  const history = useHistory()
  const { settings } = useOrganizationSettings()

  const remainingProviderScreenings = settings?.remainingProviderScreenings ?? 0
  const hasRemainingProviderScreenings = Boolean(remainingProviderScreenings)

  return (
    <Button
      sx={{
        color: hasRemainingProviderScreenings ? palette.primary.main : palette.semantic.error,
      }}
      startIcon={hasRemainingProviderScreenings ? <AutoAwesomeOutlined /> : <ErrorOutlineOutlined />}
      onClick={() =>
        history.push(
          generatePath(paths.configurations, {
            configurationsPage: CONFIGURATION_PAGE_IDS.AiScreening,
          }),
        )
      }
    >
      {formatMessage(
        { id: 'dashboard.sourcing.remainingProviderScreenings.availableWithCount' },
        { count: remainingProviderScreenings },
      )}
    </Button>
  )
}

export default RemainingProviderScreeningsButton
